var React = require('react');

function FlagLc (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M503.172 423.724H8.828A8.829 8.829 0 010 414.896V97.104a8.829 8.829 0 018.828-8.828h494.345a8.829 8.829 0 018.828 8.828v317.792a8.83 8.83 0 01-8.829 8.828z","fill":"#3cc8ff","key":0}),React.createElement("path",{"fill":"#464655","d":"M255.999 114.759L132.414 397.241h247.171z","key":1}),React.createElement("path",{"d":"M255.999 158.807l96.591 220.779H159.408l96.591-220.779m0-44.048L132.414 397.241h247.172L255.999 114.759z","fill":"#f5f5f5","key":2}),React.createElement("path",{"fill":"#ffe15a","d":"M132.414 397.241L255.999 256l123.586 141.241z","key":3})]);
}

FlagLc.defaultProps = {"viewBox":"0 0 512.001 512.001"};

module.exports = FlagLc;

FlagLc.default = FlagLc;
